import { TELEGRAM_CONFIG } from "../constants/contact";

const TELEGRAM_API_BASE = "https://api.telegram.org";

export async function sendTelegramMessage(message) {
  const trimmedMessage = message.trim();
  if (!trimmedMessage) {
    throw new Error("Message can not be empty.");
  }

  const { botToken, chatId } = TELEGRAM_CONFIG;

  if (!botToken || !chatId) {
    throw new Error("Telegram credentials are missing.");
  }

  const response = await fetch(
    `${TELEGRAM_API_BASE}/bot${botToken}/sendMessage`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        chat_id: chatId,
        text: trimmedMessage,
        parse_mode: "Markdown",
      }),
    }
  );

  if (!response.ok) {
    const errorMessage = await response.text();
    throw new Error(errorMessage || "Failed to send Telegram message.");
  }

  return response.json();
}
